import { Box, Chip, Stack, Tab, TabList } from "@compass/core";
import { SurveyViewResource } from "generated/openApi";
import "moment-timezone";
import { SurveyTab } from "./SurveyPage";

export const SurveyPageTabs = (props: {
  viewResource: SurveyViewResource;
  setCurrentTab: (value: SurveyTab) => void;
}) => {
  const tabs: SurveyTab[] = ["General", "Sections", "Questions"];

  const tabTotals: [SurveyTab, number | undefined][] = [
    ["Sections", props.viewResource.formSectionCount],
    ["Questions", props.viewResource.formQuestionCount],
  ];

  return (
    <TabList
      onChange={(e, value) => props.setCurrentTab(value)}
      variant="scrollable"
      scrollButtons
      allowScrollButtonsMobile
    >
      {tabs.map((tab) => {
        const total: number | undefined = tabTotals.find((x) => x[0] === tab)?.[1];

        return (
          <Tab
            key={tab}
            label={
              <Stack direction="row" spacing="sm" alignItems="center">
                <Box>{tab}</Box>
                {total !== undefined && total !== null && <Chip label={total} size="small" />}
              </Stack>
            }
            value={tab}
          />
        );
      })}
    </TabList>
  );
};
